import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class IsLoadingServiceService {
    private isLoadingMap: Map<string, boolean> = new Map<string, boolean>(); // Loading Map für LoadingIndicator swt-table, wenn Tabelle noch nicht geladen ist

    public isLoading = false;

    public add(key: string): void {
        this.isLoadingMap.set(key, true);
        this.isLoading = this.getLoading();
    }

    public remove(key: string): void {
        this.isLoadingMap.delete(key);
        this.isLoading = this.getLoading();
    }

    public getLoading(): boolean {
        for (const key of this.isLoadingMap.keys()) {
            if (this.isLoadingMap.get(key)) {
                return true;
            }
        }
        return false;
    }

    public getLoadingByKey(key: string): boolean {
        return Boolean(this.isLoadingMap.get(key));
    }
}
